export const FETCH_SUBMITTED_TO_TYPIST_VISITS = "[GROUP_ADMIN] FETCH_SUBMITTED_TO_TYPIST_VISITS";
export const FETCH_SUBMITTED_TO_TYPIST_VISITS_START = "[GROUP_ADMIN] FETCH_SUBMITTED_TO_TYPIST_VISITS_START";
export const FETCH_SUBMITTED_TO_TYPIST_VISITS_SUCCESS = "[GROUP_ADMIN] FETCH_SUBMITTED_TO_TYPIST_VISITS_SUCCESS";
export const FETCH_SUBMITTED_TO_TYPIST_VISITS_ERROR = "[GROUP_ADMIN] FETCH_SUBMITTED_TO_TYPIST_VISITS_ERROR";
export const SET_SUBMITTED_TO_TYPIST_VISITS_PAGINATION = "[GROUP_ADMIN] SET_SUBMITTED_TO_TYPIST_VISITS_PAGINATION";

export const fetchSubmittedToTypistVisits = (data) => {
    return {
        type: FETCH_SUBMITTED_TO_TYPIST_VISITS,
        payload: data
    }
}